import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const Thresholds = ({ errors }) => {
  const thresholds = { ...forms.adminPanelsUser.userEdit.thresholds };
  return (
    <div className="admin-patient-form-block">
      <span>Patient Thresholds</span>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Systolic</span>
            <Row>
              {thresholds.systolic.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Diastolic</span>
            <Row>
              {thresholds.diastolic.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Pulse</span>
            <Row>
              {thresholds.pulse.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Glucose</span>
            <Row>
              {thresholds.glucose.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Resting Pulse</span>
            <Row>
              {thresholds.sleepPulse.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>Weight</span>
            <Row>
              {thresholds.weight.map((field) => (
                <Col lg="4" md="4" sm="4" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>PEF</span>
            <Row>
              {thresholds.pef.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col>
          <div className="admin-patient-form-block">
            <span>FEV1</span>
            <Row>
              {thresholds.fev1.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="admin-patient-form-block">
            <span>Sp02</span>
            <Row>
              {thresholds.sp02.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
                  <Input {...field} />
                  {errors[field.id] ? (
                    <div className="input-error">{errors[field.id]}</div>
                  ) : null}
                </Col>
              ))}
            </Row>
          </div>
        </Col>
        <Col />
      </Row>
    </div>
  );
};

Thresholds.propTypes = {
  errors: PropTypes.shape(),
};

export default Thresholds;
